import { exists } from '@/api'

export interface AuthUserTopMenu {
  id: number
  name: string
  readingInside: number
  readingInsideCollectionList: number
  bibliographyIntegration: number
  bibliographyCollectionBulkEdit: number
  bookbinding: number
  shelfTypeTempChange: number
  orderListCreate: number
  orderListSearch: number
  simpleOrdering: number
  acceptCollection: number
  acceptCollectionSimple: number
  acceptCollectionActual: number
  acceptCollectionMagazine: number
  reservationContact: number
  reservationCancel: number
  reservePreferenceAssign: number
  reservationCandidateList: number
  collectionList: number
  interlibraryLoanLendHistory: number
  interlibraryLoanBorrowingHistory: number
  forwardRequestStatus: number
  forwardRequestAnswer: number
  authorityEdit: number
  operationMenu: number
  passwordChange: number
  defaultValueSetting: number
  inspectionList: number
  inspectionBulkUpdate: number
  batchMenu: number
  jobList: number
  referenceRegister: number
  revision: number
}

export const defaultAuthUserTopMenu = (): AuthUserTopMenu => ({
  id: 0,
  name: '',
  readingInside: 0,
  readingInsideCollectionList: 0,
  bibliographyIntegration: 0,
  bibliographyCollectionBulkEdit: 0,
  bookbinding: 0,
  shelfTypeTempChange: 0,
  orderListCreate: 0,
  orderListSearch: 0,
  simpleOrdering: 0,
  acceptCollection: 0,
  acceptCollectionSimple: 0,
  acceptCollectionActual: 0,
  acceptCollectionMagazine: 0,
  reservationContact: 0,
  reservationCancel: 0,
  reservePreferenceAssign: 0,
  reservationCandidateList: 0,
  collectionList: 0,
  interlibraryLoanLendHistory: 0,
  interlibraryLoanBorrowingHistory: 0,
  forwardRequestStatus: 0,
  forwardRequestAnswer: 0,
  authorityEdit: 0,
  operationMenu: 0,
  passwordChange: 0,
  defaultValueSetting: 0,
  inspectionList: 0,
  inspectionBulkUpdate: 0,
  batchMenu: 0,
  jobList: 0,
  referenceRegister: 0,
  revision: 0
})

export function AuthUserTopMenuFromJSON(json: any): AuthUserTopMenu {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    readingInside: exists(json, 'reading_inside') ? json.reading_inside : 0,
    readingInsideCollectionList: exists(json, 'reading_inside_collection_list')
      ? json.reading_inside_collection_list
      : 0,
    bibliographyIntegration: exists(json, 'bibliography_integration')
      ? json.bibliography_integration
      : 0,
    bibliographyCollectionBulkEdit: exists(
      json,
      'bibliography_collection_bulk_edit'
    )
      ? json.bibliography_collection_bulk_edit
      : 0,
    bookbinding: exists(json, 'bookbinding') ? json.bookbinding : 0,
    shelfTypeTempChange: exists(json, 'shelf_type_temp_change')
      ? json.shelf_type_temp_change
      : 0,
    orderListCreate: exists(json, 'order_list_create')
      ? json.order_list_create
      : 0,
    orderListSearch: exists(json, 'order_list_search')
      ? json.order_list_search
      : 0,
    simpleOrdering: exists(json, 'simple_ordering') ? json.simple_ordering : 0,
    acceptCollection: exists(json, 'accept_collection')
      ? json.accept_collection
      : 0,
    acceptCollectionSimple: exists(json, 'accept_collection_simple')
      ? json.accept_collection_simple
      : 0,
    acceptCollectionActual: exists(json, 'accept_collection_actual')
      ? json.accept_collection_actual
      : 0,
    acceptCollectionMagazine: exists(json, 'accept_collection_magazine')
      ? json.accept_collection_magazine
      : 0,
    reservationContact: exists(json, 'reservation_contact')
      ? json.reservation_contact
      : 0,
    reservationCancel: exists(json, 'reservation_cancel')
      ? json.reservation_cancel
      : 0,
    reservePreferenceAssign: exists(json, 'reserve_preference_assign')
      ? json.reserve_preference_assign
      : 0,
    reservationCandidateList: exists(json, 'reservation_candidate_list')
      ? json.reservation_candidate_list
      : 0,
    collectionList: exists(json, 'collection_list') ? json.collection_list : 0,
    interlibraryLoanLendHistory: exists(json, 'interlibrary_loan_lend_history')
      ? json.interlibrary_loan_lend_history
      : 0,
    interlibraryLoanBorrowingHistory: exists(
      json,
      'interlibrary_loan_borrowing_history'
    )
      ? json.interlibrary_loan_borrowing_history
      : 0,
    forwardRequestStatus: exists(json, 'forward_request_status')
      ? json.forward_request_status
      : 0,
    forwardRequestAnswer: exists(json, 'forward_request_answer')
      ? json.forward_request_answer
      : 0,
    authorityEdit: exists(json, 'authority_edit') ? json.authority_edit : 0,
    operationMenu: exists(json, 'operation_menu') ? json.operation_menu : 0,
    passwordChange: exists(json, 'password_change') ? json.password_change : 0,
    defaultValueSetting: exists(json, 'default_value_setting')
      ? json.default_value_setting
      : 0,
    inspectionList: exists(json, 'inspection_list') ? json.inspection_list : 0,
    inspectionBulkUpdate: exists(json, 'inspection_bulk_update')
      ? json.inspection_bulk_update
      : 0,
    batchMenu: exists(json, 'batch_menu') ? json.batch_menu : 0,
    jobList: exists(json, 'job_list') ? json.job_list : 0,
    referenceRegister: exists(json, 'reference_register')
      ? json.reference_register
      : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
